import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { QuoteSchema } from "../generated/prisma/zod";

const c = initContract();
export const quotesContract = c.router({
  create: {
    method: "POST",
    path: "/quotes",
    body: z.object({
      quoteRequestId: z.string().uuid(),
      batches: z
        .object({
          partId: z.string().uuid(),
          assemblies: z
            .object({
              parentId: z.string().uuid(),
              children: z.string().uuid().array(),
            })
            .array(),
        })
        .array(),
    }),
    responses: {
      201: QuoteSchema,
    },
  },

  send: {
    method: "POST",
    path: "/quotes/:id/send",
    body: z.object({
      body: z.string().optional(),
      cc: z.array(z.string()).optional(),
      attachments: z
        .array(
          z.object({
            filename: z.string(),
            content: z.string(),
          }),
        )
        .optional(),
    }),
    responses: {
      200: QuoteSchema,
    },
  },
});
